/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import { RECEIVED_UPDATE_CUSTOMER_PREFERENCES } from 'state/preferences/PreferencesActions';

const initState = [];
export const selectedAccountVisibilityReducer = (state = initState, action) => {
  if (action.type === RECEIVED_UPDATE_CUSTOMER_PREFERENCES) {
    const { accountVisibility } = action.preferences;
    if (accountVisibility && accountVisibility.length > 0) {
      return accountVisibility;
    }
  }
  return state;
};
selectedAccountVisibilityReducer.priority = 17;
